// src/Component/GlobalLoader.jsx
import React from 'react';
import { useSelector } from 'react-redux';
import { selectIsLoading, selectLoadingMessage } from '../features/loading/loadingSlice';
import '../CSS/GlobalLoader.css';

const GlobalLoader = () => {
  const isLoading = useSelector(selectIsLoading);
  const loadingMessage = useSelector(selectLoadingMessage);

  if (!isLoading) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="global-loader-backdrop" />
      
      {/* Loader Container */}
      <div className="global-loader-container">
        <div className="global-loader-content">
          {/* GIF Loader */}
          <div className="global-loader-gif">
            <img 
              src="https://jessicaspiezio.com/portfolioImages/loader.gif" 
              alt="Loading..." 
              className="loader-gif-image"
            />
          </div>
          
          {/* Loading Message */}
          <p className="global-loader-message">{loadingMessage}</p>
        </div>
      </div>
    </>
  );
};

export default GlobalLoader;

// Alternative: Simple overlay loader with GIF
export const SimpleGlobalLoader = () => {
  const isLoading = useSelector(selectIsLoading);
  const loadingMessage = useSelector(selectLoadingMessage);

  if (!isLoading) return null;

  return (
    <div className="simple-global-loader">
      <div className="simple-loader-overlay">
        <div className="simple-loader-content">
          <img 
            src="https://i.pinimg.com/originals/dc/cc/84/dccc846959dffafa30a836dfacf9bab9.gif" 
            alt="Loading..." 
            className="simple-loader-gif"
          />
          <span>{loadingMessage}</span>
        </div>
      </div>
    </div>
  );
};

// Hook for checking specific action loading state
export const useActionLoading = (actionType) => {
  return useSelector(state => 
    state.loading.loadingActions.includes(actionType)
  );
};